import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import theme from 'shared/constants/theme.json';

const HubspotStatus = ({ hubspotDealRecordId }) => {
  if (hubspotDealRecordId) {
    return <Button icon={<CheckCircleOutlined style={{ color: theme['success-color'] }} />} key="hubspot" href={`https://app.hubspot.com/contacts/8819850/deal/${hubspotDealRecordId}`} target="_blank">Connected to HubSpot</Button>;
  }
  return <Button icon={<ExclamationCircleOutlined style={{ color: theme['error-color'] }} />} key="hubspot">Not Connected to HubSpot</Button>;
};

export default HubspotStatus;
